  export const getTranslation = ($this = {}, language = { key: 'languages_code', code: 'en-US' }, translationsFieldName = 'translations' ) => {
    // return {} if translations field is absent
    if (!$this[translationsFieldName]) return {};

    // return {} if no translation was provided for that language
    if (!$this[translationsFieldName].filter(translation => translation[language.key] === language.code).length) return {};

    return $this[translationsFieldName].filter(translation => translation[language.key] === language.code)[0];
  };